// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-header-right[data-v-4c7e8cec] {\n  position: absolute;\n  top: 40px;\n  bottom: 0;\n  right: 30px;\n}\n.page-header-actions[data-v-4c7e8cec] {\n  margin-top: 40px;\n  position: absolute;\n  bottom: 20px;\n}\n.panel[data-v-4c7e8cec] {\n  margin-top: 3px;\n}\nbutton > label[data-v-4c7e8cec] {\n  margin: 0px;\n  cursor: pointer;\n}\n.input-select-file[data-v-4c7e8cec] {\n  width: 0px;\n  visibility: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
